import { InspectorField } from "./fields/InspectorField";
import { PathFragment } from "./fields/InspectorReference";
import { InspectorCreator } from "./InspectorCreator";
import { List } from "./types/List";

export class InspectorCreationInfo
{
  creator:InspectorCreator;
  root:any;
  parent:any;
  parentField:InspectorField<any>;
  path:PathFragment;
  object:any;
  level:number = 0;
  children:InspectorField<any>[] = [];

  get childrenFieldNames()
  {
    return this.children.map( c => ( c.info.path + "" ) ); 
  }

  clone()
  {
    let info = new InspectorCreationInfo();

    info.creator     = this.creator;
    info.root        = this.root;
    info.parent      = this.parent;
    info.parentField = this.parentField;
    info.path        = this.path;
    info.object      = this.object;
    info.level       = this.level;

    return info;
  }

  setValue( value:any )
  {
    this.parent[ this.path + "" ] = value; 
  }

  arrayEntry( index:number, field:InspectorField<any> )
  {
    let clone = this.clone();

    clone.parent = this.object;
    clone.parentField = field;
    clone.path   = PathFragment.asIndex( index );
    clone.object = this.object[ index ];

    clone.level ++;

    return clone;
  }

  listEntry( index:number, field:InspectorField<any> )
  {
    let clone = this.clone();

    clone.parent = this.object;
    clone.parentField = field;
    clone.path   = PathFragment.asListEntry( index );
    clone.object = ( this.object as List<any> ).get( index );

    clone.level ++;

    return clone;
  }

  objectMember( name:string, field:InspectorField<any> )
  {
    let clone = this.clone();

    clone.parent = this.object;
    clone.parentField = field;
    clone.path   = PathFragment.asMember( name );
    clone.object = this.object[ name ];

    clone.level ++;

    return clone;
  }
  
}